interface SectionTitleProps {
    title: string;
}

export function SectionTitle({ title }: SectionTitleProps) {
    return (
        <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white">
                {title}
            </h2>
            <div className="mt-3 w-16 h-1 bg-blue-600 dark:bg-blue-400 rounded-full" />
        </div>
    );
}
